export default class StringHelper {
  static removeAccents(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
  }

  static titleize(string) {
    if(string == undefined || string == null) return null
    string = string.trim();
    return string.split(' ').map(word => word[0].toUpperCase() + word.slice(1, word.length)).join(' ')
  }
}



// WEBPACK FOOTER //
// ./src/utils/string-helper.js